var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPitchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5007 0C6.43372 0 3.125 3.30872 3.125 7.37565C3.125 12.4573 9.74707 20.4421 10.029 20.7795C10.2743 21.0733 10.7266 21.0737 10.9723 20.7795C11.2542 20.4421 17.8763 12.4573 17.8763 7.37565C17.8763 3.30872 14.5676 0 10.5007 0ZM10.5007 19.4042C8.987 17.4808 4.35428 11.2748 4.35428 7.37565C4.35428 3.98654 7.11154 1.22928 10.5007 1.22928C13.8898 1.22928 16.647 3.98654 16.647 7.37565C16.647 11.2748 12.0143 17.4808 10.5007 19.4042Z",
    fill: "#0E142C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8016 6.76096H14.1355C13.8757 5.219 12.6557 3.99906 11.1138 3.73928V3.07313C11.1138 2.73369 10.8386 2.4585 10.4991 2.4585C10.1597 2.4585 9.88449 2.73369 9.88449 3.07313V3.73928C8.34253 3.99911 7.1226 5.21904 6.86281 6.76096H6.19667C5.85723 6.76096 5.58203 7.03615 5.58203 7.3756C5.58203 7.71504 5.85723 7.99023 6.19667 7.99023H6.86281C7.1226 9.5322 8.34253 10.7521 9.88449 11.0119V11.6781C9.88449 12.0175 10.1597 12.2927 10.4991 12.2927C10.8386 12.2927 11.1138 12.0175 11.1138 11.6781V11.0119C12.6557 10.7521 13.8757 9.53215 14.1355 7.99023H14.8016C15.141 7.99023 15.4162 7.71504 15.4162 7.3756C15.4162 7.03615 15.1411 6.76096 14.8016 6.76096ZM10.4991 9.83415C9.14349 9.83415 8.04058 8.73124 8.04058 7.3756C8.04058 6.01995 9.14349 4.91705 10.4991 4.91705C11.8548 4.91705 12.9577 6.01995 12.9577 7.3756C12.9577 8.73124 11.8548 9.83415 10.4991 9.83415Z",
    fill: "#0E142C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitchIcon);
export default __webpack_public_path__ + "static/media/pitch-icon.e9a3f568812c6f197270b07e4a4b4b90.svg";
export { ForwardRef as ReactComponent };